import { ArticlePullQuoteProps } from "~/components/ArticlePullQuote/ArticlePullQuote";
import { extractTextFromHTML } from "~/lib/shared/html-utils";
import { PullQuoteContentBlock } from "~/types/asgard/PostContentBlock";

export const apiToPullQuoteProps = (
  pullQuote: PullQuoteContentBlock
): ArticlePullQuoteProps => ({
  byline: extractTextFromHTML(pullQuote.byline),
  quote: extractTextFromHTML(pullQuote.pull_quote),
});
